var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative w-100" }, [
    _c("div", { staticClass: "relative swiper-bg" }, [
      _c(
        "div",
        { staticClass: "relative mw8-25 center" },
        [_vm._t("fixed-bg-contents")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }